import React, { useCallback, useEffect, useState } from 'react'
import {grantAnyPermissionOf} from "../../../hoc/RoleService/RoleService";
import BannerAircraftHighlightedKBD from './BannerAircraftHighlightedKBD';
import Spinner from "../../../components/UI/Spinner/Spinner";
import MessageInfo from "../../../components/Messages/MessageInfo";

const HighlightedKnowledgeBaseDocuments = props => {
    const { auth, transportUnitUuid } = props;
    const [highlightedDocuments, setHighlightedDocuments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const loadData = useCallback(() => {
        if (!grantAnyPermissionOf(['role_public_kb', 'role_private_kb'], auth)) {
            return;
        }

        setError(false);
        setLoading(true);

        auth.fetch('knowledge_base_documents/' + transportUnitUuid + '/highlighted')
            .then(res => {
                if (res['@type'] && res['@type'] === 'hydra:Error') {
                    setError(true);
                } else {
                    setHighlightedDocuments(res['hydra:member'] ?? []);
                }
                setLoading(false);
            })
            .catch(e => {
                setError(true);
                setLoading(false);
            });
    }, [auth, transportUnitUuid]);

    useEffect(() => {
        loadData();
    }, [loadData]);

    const refreshHandler = () => {
        loadData();
    };

    if (loading) {
        return <Spinner small={true} />;
    }

    if (error) {
        return <MessageInfo refreshHandler={refreshHandler} message="Error while loading the knowledge base documents details" />
    }

    if (!highlightedDocuments) {
        return null;
    }

    return (
        <>
            {highlightedDocuments.map((document, key) => {
                return <BannerAircraftHighlightedKBD key={key} document={document} auth={auth} />;
            })}
        </>
    );
}

export default HighlightedKnowledgeBaseDocuments;
